/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import RazorPay from "./RazorPay";
import PayPal from "./PayPal";
import { showToast } from "../showTost";
import { useTranslation } from "react-i18next";
import Stripe from "./Stripe";
import Paystack from "./Paystack";
import Flutterwave from "./Flutterwave";
import SenangPay from "./SenangPay";
import Midtrans from "./Midtrans";
import PayFast from "./PayFast";
import Loading from "../component/Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../component/ImageLoad";
export const ImgLoad = ({ url, style }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <img
      src={url}
      alt="Model"
      loading="lazy"
      onLoad={() => setImgLoaded(true)}
      onError={() => setImgLoaded(true)}
      className={`${style} ${imgLoaded ? "opacity-100" : "opacity-0"}`}
    />
  );
};

const Payment = ({ Amount, Data, INDEX, photos, did }) => {
  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl, setPaymentStatus, apiloading } =
    useContext(MyContext);
  const [paymentList, setPaymentList] = useState([]);
  const [selectPaymentId, setSelectPaymentId] = useState();
  const [isShow, setIsShow] = useState(false);
  const [attribute, setAttribute] = useState("");

  useEffect(() => {
    axios
      .get(`${ApiBaseUrl}/customer/payment_list`)
      .then((res) => {
        // console.log("payment_list", res);
        setPaymentList(res.data.payment_list);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const SelectPayment = (item) => {
    setSelectPaymentId(item.id);
    setAttribute(item.attribute);
  };

  const HandleContinue = () => {
    if (!selectPaymentId) {
      showToast({ title: t("Select Payment Method"), id: "error" });
      return;
    }

    sessionStorage.setItem("Paymentid", selectPaymentId);

    if (selectPaymentId === 1) {
      setIsShow(true);
      return;
    }

    if (selectPaymentId === 16) {
      setPaymentStatus("PaymentDone");
      return;
    }

    if (Data) {
      const PaymentData = {
        ...Data,
        status: "1",
        payment_id: selectPaymentId,
      };

      sessionStorage.setItem("PaymentData", JSON.stringify(PaymentData));

      const Userid = secureLocalStorage.getItem("Userid");

      if (photos && did) {
        const formData = new FormData();
        formData.append("uid", Userid);
        formData.append("doctor_id", did);

        photos.forEach((photo) => {
          formData.append("image", photo);
        });

        axios
          .post(`${ApiBaseUrl}/customer/add_patient_prescription`, formData)
          .then((res) => {
            // console.log("add_patient_prescription", res);
          })
          .catch((error) => {
            console.error(error);
          });
      }
      setIsShow(true);
    }
  };

  return (
    <>

      <div className="h-full pr-1 scroll-container overflow-hidden space-y-3">
        {paymentList.length >= 1 ? (
          paymentList.map((item, index) => (
            <label
              key={index}
              onClick={() => SelectPayment(item)}
              className={`flex items-center gap-3 p-3.5 border rounded-2xl cursor-pointer transition-all duration-150 ${
                selectPaymentId === item.id
                  ? "border-indigo-600 bg-indigo-50/30"
                  : "border-slate-200 hover:border-slate-300"
              }`}
            >
              <div className="w-12 h-12 rounded-xl overflow-hidden border border-slate-150 shrink-0 bg-slate-50">
                <ImageLoad
                  src={ImgBaseUrl + item.image}
                  CustomeStyle="w-full h-full object-cover"
                  alt="Payment Img"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-bold text-slate-800 text-sm">
                  {item.name}
                </h4>
                <p className="text-slate-400 text-xs font-medium">
                  {item.sub_title}
                </p>
              </div>
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center border-2 shrink-0 transition-colors duration-150 border-slate-300 border-solid"
                style={{
                  borderColor:
                    selectPaymentId === item.id ? "#4f46e5" : undefined,
                }}
              >
                <span
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-150 ${selectPaymentId === item.id ? "bg-indigo-600 scale-100" : "scale-0"}`}
                ></span>
              </div>
            </label>
          ))
        ) : (
          <div className="h-24 flex items-center justify-center">
            <span className="text-slate-400 text-sm font-medium animate-pulse">
              Loading...
            </span>
          </div>
        )}
      </div>

      <button onClick={HandleContinue} className="payment-btn mt-[5px]">
        {apiloading ? (
          <div className="loader mx-auto"></div>
        ) : (
          <span>{t("Continue")}</span>
        )}
      </button>

      {selectPaymentId === 1 && isShow && (
        <RazorPay Amount={Amount} Attribute={attribute} />
      )}
      {selectPaymentId === 2 && isShow && <PayPal Amount={Amount} />}
      {selectPaymentId === 3 && isShow && <Stripe Amount={Amount} />}
      {selectPaymentId === 4 && isShow && <Paystack Amount={Amount} />}
      {selectPaymentId === 5 && isShow && <Flutterwave Amount={Amount} />}
      {selectPaymentId === 7 && isShow && <SenangPay Amount={Amount} />}
      {selectPaymentId === 9 && isShow && <PayFast Amount={Amount} />}
      {selectPaymentId === 10 && isShow && <Midtrans Amount={Amount} />}
    </>
  );
};

export default Payment;
/* jshint ignore:end */
